"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectViewQuestionSelections = exports.selectViewQuestionInfo = exports.selectSkippedQuestionIds = exports.selectQuestionsSelections = exports.selectQuestions = exports.selectQuestionnaireProgress = exports.selectQuestionnaireAnswers = exports.selectQuestionIndexInFlow = exports.selectMetadata = exports.selectIsExclusiveSelection = exports.selectIsBudgetAdjusted = exports.selectHandsetSearchList = exports.selectDefaultMetadata = exports.selectCurrentSelections = exports.selectCurrentQuestionIndex = exports.selectCurrentQuestion = exports.selectBudget = void 0;
var _widgetSelectors = require("../widget/widgetSelectors");
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _utils = require("../../utils/utils");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const selectQuestions = instanceId => state => {
  return state.drools[instanceId].questionnaire.questions;
};
exports.selectQuestions = selectQuestions;
const selectQuestionnaireProgress = instanceId => state => {
  return state.drools[instanceId].questionnaire.progressBarPercentage;
};
exports.selectQuestionnaireProgress = selectQuestionnaireProgress;
const selectCurrentQuestion = instanceId => state => {
  const questions = selectQuestions(instanceId)(state);
  const {
    currentQuestionIndex
  } = state.drools[instanceId].questionnaire;
  return questions[currentQuestionIndex];
};
exports.selectCurrentQuestion = selectCurrentQuestion;
const selectViewQuestionInfo = instanceId => state => {
  const questions = selectQuestions(instanceId)(state);
  const {
    viewQuestionIndex
  } = state.drools[instanceId].questionnaire;
  return {
    question: questions[viewQuestionIndex],
    index: viewQuestionIndex
  };
};
exports.selectViewQuestionInfo = selectViewQuestionInfo;
const selectViewQuestionSelections = instanceId => state => {
  const {
    selections,
    viewQuestionIndex
  } = state.drools[instanceId].questionnaire;
  return selections[viewQuestionIndex] || [];
};
exports.selectViewQuestionSelections = selectViewQuestionSelections;
const selectCurrentSelections = instanceId => state => {
  const {
    selections,
    currentQuestionIndex
  } = state.drools[instanceId].questionnaire;
  return selections[currentQuestionIndex] || [];
};
exports.selectCurrentSelections = selectCurrentSelections;
const selectQuestionsSelections = instanceId => state => {
  const {
    selections,
    questions
  } = state.drools[instanceId].questionnaire;
  const map = {};
  questions.reduce((acc, current, index) => {
    var _current$id;
    if ((_current$id = current.id) !== null && _current$id !== void 0 && _current$id.trim()) {
      acc[current.id] = selections[index];
    }
    return acc;
  }, map);
  return map;
};
exports.selectQuestionsSelections = selectQuestionsSelections;
const selectDefaultMetadata = instanceId => state => {
  var _state$drools$instanc, _state$drools$instanc2;
  const defaultMetadata = (_state$drools$instanc = state.drools[instanceId].questionnaire.defaultMetadata) !== null && _state$drools$instanc !== void 0 ? _state$drools$instanc : [];
  const defaultFlags = (_state$drools$instanc2 = state.drools[instanceId].questionnaire.defaultFlags) !== null && _state$drools$instanc2 !== void 0 ? _state$drools$instanc2 : [];
  const widgetDefaultMetadata = (0, _widgetSelectors.selectDefaultMetadata)(instanceId)(state);
  const transformedDefaultMetadata = (0, _questionnaireUtil.transformDefaultMetadata)(widgetDefaultMetadata);
  const defaultMetadataObject = {};
  defaultMetadata.forEach(metadata => {
    defaultMetadataObject[metadata.category] = {
      ...metadata
    };
    delete defaultMetadataObject[metadata.category].category;
  });
  const finalDefaultMetadata = {
    flags: defaultFlags,
    ...(0, _deepmerge.default)(transformedDefaultMetadata, defaultMetadataObject)
  };
  return finalDefaultMetadata;
};
exports.selectDefaultMetadata = selectDefaultMetadata;
const selectSkippedQuestionIds = instanceId => state => {
  var _state$drools$instanc3;
  return (_state$drools$instanc3 = state.drools[instanceId].questionnaire.skippedQuestionIds) !== null && _state$drools$instanc3 !== void 0 ? _state$drools$instanc3 : [];
};
exports.selectSkippedQuestionIds = selectSkippedQuestionIds;
const selectMetadata = instanceId => state => {
  const {
    questionnaire
  } = state.drools[instanceId];
  const defaultMetadata = (0, _utils.clone)(selectDefaultMetadata(instanceId)(state));
  if (!(questionnaire !== null && questionnaire !== void 0 && questionnaire.answers) || (questionnaire === null || questionnaire === void 0 ? void 0 : questionnaire.answers.length) === 0) {
    return defaultMetadata;
  }
  const lastAnswer = questionnaire === null || questionnaire === void 0 ? void 0 : questionnaire.answers[(questionnaire === null || questionnaire === void 0 ? void 0 : questionnaire.answers.length) - 1];
  return (0, _deepmerge.default)(defaultMetadata, lastAnswer === null || lastAnswer === void 0 ? void 0 : lastAnswer.metadata, {
    arrayMerge: (destinationArray, sourceArray) => sourceArray
  });
};
exports.selectMetadata = selectMetadata;
const selectCurrentQuestionIndex = instanceId => state => {
  return state.drools[instanceId].questionnaire.currentQuestionIndex;
};
exports.selectCurrentQuestionIndex = selectCurrentQuestionIndex;
const selectHandsetSearchList = instanceId => state => {
  return state.drools[instanceId].questionnaire.handsetSearchList;
};
exports.selectHandsetSearchList = selectHandsetSearchList;
const selectQuestionnaireAnswers = instanceId => state => {
  return state.drools[instanceId].questionnaire.answers;
};
exports.selectQuestionnaireAnswers = selectQuestionnaireAnswers;
const selectBudget = instanceId => state => {
  return state.drools[instanceId].questionnaire.budget;
};
exports.selectBudget = selectBudget;
const selectIsBudgetAdjusted = instanceId => state => {
  return state.drools[instanceId].questionnaire.isBudgetAdjusted;
};
exports.selectIsBudgetAdjusted = selectIsBudgetAdjusted;
const selectQuestionIndexInFlow = instanceId => state => {
  return state.drools[instanceId].questionnaire.questionIndexInFlow;
};
exports.selectQuestionIndexInFlow = selectQuestionIndexInFlow;
const selectIsExclusiveSelection = instanceId => state => {
  return state.drools[instanceId].questionnaire.isExclusiveSelection;
};
exports.selectIsExclusiveSelection = selectIsExclusiveSelection;